<div class="tooltip_content">
    <div class="tooltip_text">{{tooltip.text}}</div>
</div>